export default {
  methods: {
    /**
     * Parse Date Time into JS date that is supported by Safari.
     *
     * @param  $dateTime "yyyy-mm-dd hh:mm:ss"
     * @return Date
     */
    parseDateTime(dateTime) {
      let dateString = dateTime.split('-').join('/');
      return new Date(`${dateString}`);
    },
    nearScheduledEnd(timestamp1, timestamp2) {
      let diff = Math.abs(timestamp2 - timestamp1) / 1000;
      let minutes = diff / 60;
      if (minutes <= 15) {
        return true;
      }
      return false;
    }
  },
}